//
//
//
//
//
//
//

module.exports = {
  data: function() {
    return {
      greeting: "Hello"
    };
  }
};
